import { Inject, ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core'
import { Configuration } from './configuration'
import { HttpClient } from '@angular/common/http'

@NgModule({
    imports: [],
    declarations: [],
    exports: [],
    providers: [],
})
export class BackendApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<BackendApiModule> {
        return {
            ngModule: BackendApiModule,
            providers: [{ provide: Configuration, useFactory: configurationFactory }],
        }
    }

    constructor(@Inject(BackendApiModule) @Optional() @SkipSelf() parentModule: BackendApiModule,
                @Inject(HttpClient) @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('BackendApiModule is already loaded. Import in your base AppModule only.')
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
                'See also https://github.com/angular/angular/issues/20575')
        }
    }
}
